/*
 * JARS Filter: Bedienung der Kollektionsseite (sections/jars-kollektion.liquid). Ersetzt die App „Smart Product Filter & Search“.
 * Aufbau, Klassen und Verhalten wie bei der App (am 06.10.2026 gemessen, _migration/analyse/12_belege/), Logik in jars-filter-logik.js.
 */
(function () {
  'use strict';
  const L = window.JarsFilterLogik;
  const html = document.documentElement;
  const konf = document.getElementById('jars-filter-einstellungen');
  const raster = document.getElementById('gf-products');
  const fertig = () => { html.classList.remove('spf-filter-loading'); html.classList.add('spf-status-loaded'); };
  if (!L || !konf || !raster) return fertig();

  const E = JSON.parse(konf.textContent);
  const tree = document.getElementById('gf-tree');
  const inhalt = tree.querySelector('.gf-filter-contents');
  const leiste = document.getElementById('gf-controls-container');
  const nav = document.getElementById('gf_pagination_wrap');
  const suchfeld = document.getElementById('gf-controls-search-input');
  const limitWahl = document.getElementById('setLimit');
  const sortKnopf = document.getElementById('sortButton');
  const sortListe = document.getElementById('globo-dropdown-sort_options');
  const filterKnopf = leiste.querySelector('.gf-refine-toggle-mobile button');
  const HANDY = window.matchMedia('(max-width: 768px)');
  const SHOPIFY_SORTEN = ['manual', 'most-relevant', 'best-selling', 'title-ascending', 'title-descending', 'price-ascending', 'price-descending', 'created-ascending', 'created-descending'];
  const SORT_TEXT = Object.fromEntries([...sortListe.querySelectorAll('li')].map((li) => [li.dataset.sort, li.textContent.trim()]));
  SORT_TEXT.manual = SORT_TEXT['most-relevant'] = 'Empfehlung'; // Reihenfolge der Kollektion; die App zeigte bei most-relevant den Rohtext
  SORT_TEXT.relevance = 'Relevanz'; // setzt die App beim Suchen (sort_by=relevance), steht nicht in der Liste
  const STANDARD_TEXT = SORT_TEXT[E.standardSortierung] || 'Empfehlung'; // manual / most-relevant: „Empfehlung“ wie bei der App
  const EIGENE = (k) => /^(gf_|q$|sort_by$|limit$|page$)/.test(k);
  const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const euro = (n) => '€' + n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const zahl = (n) => String(Math.round(n * 100) / 100);
  const ICON_X = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M11.414 10l6.293-6.293a1 1 0 10-1.414-1.414L10 8.586 3.707 2.293a1 1 0 00-1.414 1.414L8.586 10l-6.293 6.293a1 1 0 101.414 1.414L10 11.414l6.293 6.293A.998.998 0 0018 17a.999.999 0 00-.293-.707L11.414 10z" fill="currentColor"></path></svg>';
  const ICON_PILLE = '<svg viewBox="0 0 50 50"><path fill="currentColor" d="M25.5 6C15 6 6.5 14.5 6.5 25C6.5 35.5 15 44 25.5 44C36 44 44.5 35.5 44.5 25C44.5 14.5 36 6 25.5 6ZM34.4 31.9L32.5 33.8L25.6 26.9L18.7 33.8L16.8 31.9L23.7 25L16.8 18.1L18.7 16.2L25.6 23.1L32.5 16.2L34.4 18.1L27.4 25L34.4 31.9Z"></path></svg>';
  const pfeil = (d) => '<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="' + d + '" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>';

  // Optionen aus den Editor-Einstellungen
  const optionen = E.optionen.map((o) => ({
    ...o,
    // 13.10.2026: Zeilen mit Zuordnung „Etikett = Schlüssel Zahlen“ wie die Wertegruppen der App (jars-filter-logik.js)
    werte: o.typ === 'bereich' ? L.werteLesen(o.werte) : [],
  }));

  // Zusätzliche Parameter (z. B. Vorschau, Partnerlinks) bleiben in jeder URL erhalten
  const fremde = () => [...new URLSearchParams(location.search)].filter(([k]) => !EIGENE(k));

  async function abschnittLaden(id, params) {
    const teile = [];
    for (let n = 1; n < 50; n++) {
      const u = new URLSearchParams(fremde());
      for (const [k, v] of Object.entries(params || {})) u.set(k, v);
      u.set('section_id', id);
      u.set('page', n);
      const antwort = await fetch(location.pathname + '?' + u, { credentials: 'same-origin' });
      if (!antwort.ok) throw new Error('Abruf ' + antwort.status);
      const doc = new DOMParser().parseFromString(await antwort.text(), 'text/html');
      teile.push(doc);
      const seiten = +(doc.querySelector('[data-seiten]')?.dataset.seiten || 1);
      if (n >= seiten) break;
    }
    return teile;
  }
  const kartenAus = (docs) => docs.flatMap((d) => [...d.querySelectorAll('#gf-products > [data-handle]')]);

  // Reihenfolgen von Shopify (Standard der Kollektion, Bestseller, Titel, Datum), einmal je Sitzung geladen
  const ordnungen = new Map();
  const schluesselFuer = (s) => { const k = L.gleichstandNach(s); return SHOPIFY_SORTEN.includes(k) && k !== E.standardSortierung ? k : 'standard'; };
  async function ordnung(schluessel) {
    if (!ordnungen.has(schluessel)) {
      const karten = kartenAus(await abschnittLaden(E.abschnitt, schluessel === 'standard' ? {} : { sort_by: schluessel }));
      ordnungen.set(schluessel, new Map(karten.map((k, i) => [k.dataset.handle, i])));
    }
    return ordnungen.get(schluessel);
  }

  // Preise und Rabatt einer Karte. Wie die App: Rabatt aus data-vergleich (Vergleichspreis der Produktdaten, nur für die
  // Sortierung „% Rabatt“, nie angezeigt). Im Aktionszustand (Klasse jars-aktion-an, snippets/jars-aktion-kopf.liquid) gelten für
  // Produkte der Aktion die Aktionspreise und der 30-Tage-Tiefstpreis aus data-aktion-preise/-vergleich (09.10.2026).
  function preisDaten(el) {
    const cent = (s) => String(s || '').split(',').map((x) => (x === '' ? null : parseInt(x, 10) / 100));
    const aktion = html.classList.contains('jars-aktion-an') && el.dataset.aktionPreise;
    const preise = cent(aktion ? el.dataset.aktionPreise : el.dataset.preise).filter((x) => x !== null);
    const vergleich = cent(aktion ? el.dataset.aktionVergleich : el.dataset.vergleich);
    let rabatt = 0;
    preise.forEach((p, k) => { const v = vergleich[k]; if (v && v > p) rabatt = Math.max(rabatt, (v - p) / v); });
    return { preise, rabatt };
  }
  function aufnehmen(el, i) {
    const { preise, rabatt } = preisDaten(el);
    return { el, start: i, index: i, handle: el.dataset.handle, tags: JSON.parse(el.dataset.tags || '[]'), preise, rabatt, verfuegbar: el.dataset.verfuegbar === 'true', titel: el.dataset.suche || '', hersteller: '', typ: '' };
  }

  let produkte = [];
  // Adress-Parameter wie bei der App (Reihenfolge = Reihenfolge des Setzens, Rohwerte), daraus der Filterzustand
  const url = (pp, ohne) => L.urlAusParametern(pp, E.standardSortierung, ohne);
  let p = L.parameterAusUrl(location.search, E.standardSortierung);
  let z = L.zustandAusUrl(url(p), optionen);
  const sortierung = () => (SORT_TEXT[z.sortierung] ? z.sortierung : E.standardSortierung);

  // Suchtext aus den Beschreibungen (sections/jars-suchindex.liquid), erst bei der ersten Suche oder beim Fokus des Suchfelds.
  // 21.10.2026: Ladevorgang wird gemerkt; ein zweiter Aufruf während des Ladens wartet darauf, statt ohne Beschreibungstext zu suchen.
  // Schlägt der Abruf fehl, versucht es der nächste Aufruf erneut.
  let suchindexLauf = null;
  function suchindexLaden() {
    if (!suchindexLauf) suchindexLauf = (async () => {
      const s = {};
      for (const doc of await abschnittLaden('jars-suchindex', {})) Object.assign(s, JSON.parse(doc.querySelector('script[data-seiten]')?.textContent || '{}'));
      for (const p of produkte) p._suchtext += ' ' + (s[p.handle] || '');
    })().catch((fehler) => { suchindexLauf = null; throw fehler; });
    return suchindexLauf;
  }

  // ---------- Darstellung ----------
  // aufgeklappte Preisblöcke: wie bei der App anfangs zu, nur bei den Nur-Preis-Kollektionen (App-Set 61344) offen (13.10.2026)
  const offen = new Set(optionen.filter((o) => o.typ === 'preis' && o.offen).map((o) => o.id));
  const zu = new Set(); // zugeklappte Werteblöcke
  const istGewaehlt = (o, wert) => (z.auswahl[o.id] || []).includes(wert);

  function titelBlock(o, aufgeklappt, loeschbar) {
    return '<div class="gf-block-title"><div class="h3" role="button" tabindex="0" aria-expanded="' + aufgeklappt + '" aria-controls="filter-content-' + o.id + '" id="filter-trigger-' + o.id + '"><span>' + esc(o.titel) + '</span></div>' +
      (loeschbar ? '<a class="gf-clear" tabindex="0" role="button" data-fid="' + o.id + '" aria-label="Filter entfernen: ' + esc(o.titel) + '">Löschen</a>' : '') + '</div>';
  }

  function preisBlock(o, basis) {
    const alle = basis.flatMap((p) => p.preise);
    if (!alle.length) return '';
    const lo = Math.min(...alle), hi = Math.max(...alle);
    const von = z.preis ? z.preis.min : lo, bis = z.preis ? z.preis.max : hi;
    const auf = offen.has(o.id);
    const pos = (v) => (hi > lo ? Math.min(100, Math.max(0, ((v - lo) / (hi - lo)) * 100)) : 0);
    const a = pos(von), b = pos(bis);
    const griff = (k, v, p, label) => '<div class="noUi-origin" style="transform: translate(' + ((p - 100) * 10) + '%, 0px); z-index: ' + (k ? 4 : 5) + ';"><div class="noUi-handle noUi-handle-' + (k ? 'upper' : 'lower') + '" data-handle="' + k + '" tabindex="0" role="slider" aria-orientation="horizontal" aria-valuemin="' + zahl(lo) + '" aria-valuemax="' + zahl(hi) + '" aria-valuenow="' + zahl(v) + '" aria-valuetext="' + v.toFixed(2) + '" aria-labelledby="' + label + '-label-' + o.id + '"><div class="noUi-touch-area"></div></div></div>';
    return '<div data-filter-type="Price" data-filter-id="' + o.id + '" role="group" aria-labelledby="filter-trigger-' + o.id + '" class="gf-option-block gf-option-' + o.id + ' gf-option-block-slider ' + (o.offen ? 'none' : 'capitalize') + (auf ? '' : ' is-collapsed') + '">' +
      titelBlock(o, auf, !!z.preis) +
      '<div class="gf-block-content" id="filter-content-' + o.id + '" role="region" aria-labelledby="filter-trigger-' + o.id + '"><div class="gf-scroll"><div class="gf-option-box"><div>' +
      '<div class="gf-range-inputs"><label for="min-' + o.id + '" id="min-label-' + o.id + '" class="sr-only">' + esc(o.titel) + ' Min</label><input class="gf-range-min" id="min-' + o.id + '" value="' + zahl(von) + '" type="text" inputmode="decimal" aria-labelledby="min-label-' + o.id + '"><span class="gf-range-split"> - </span><label for="max-' + o.id + '" id="max-label-' + o.id + '" class="sr-only">' + esc(o.titel) + ' Max</label><input class="gf-range-max" id="max-' + o.id + '" value="' + zahl(bis) + '" type="text" inputmode="decimal" aria-labelledby="max-label-' + o.id + '"></div>' +
      '<div class="gf-range-slider noUi-target noUi-ltr noUi-horizontal noUi-txt-dir-ltr" data-min="' + lo + '" data-max="' + hi + '" data-id="' + o.id + '" id="slider-' + o.id + '"><div class="noUi-base"><div class="noUi-connects"><div class="noUi-connect" style="transform: translate(' + a + '%, 0px) scale(' + (b - a) / 100 + ', 1);"></div></div>' +
      griff(0, von, a, 'min') + griff(1, bis, b, 'max') + '</div>' +
      '<div class="noUi-pips noUi-pips-horizontal"><div class="noUi-marker noUi-marker-horizontal noUi-marker-large" style="left: 0%;"></div><div class="noUi-value noUi-value-horizontal noUi-value-large" style="left: 0%;">' + euro(lo) + '</div>' +
      [20, 40, 60, 80].map((l) => '<div class="noUi-marker noUi-marker-horizontal noUi-marker-normal" style="left: ' + l + '%;"></div>').join('') +
      '<div class="noUi-marker noUi-marker-horizontal noUi-marker-large" style="left: 100%;"></div><div class="noUi-value noUi-value-horizontal noUi-value-large" style="left: 100%;">' + euro(hi) + '</div></div></div>' +
      '</div></div></div></div></div>';
  }

  function werteBlock(o) {
    const zahlen = L.zaehlen(produkte, optionen, z, o);
    const werte = o.werte.filter((w) => zahlen[w.wert] > 0 || istGewaehlt(o, w.wert));
    if (!werte.length) return '';
    const auf = !zu.has(o.id);
    const gewaehlt = (z.auswahl[o.id] || []).length > 0;
    const kopf = '<div data-filter-type="Tag" data-filter-id="' + o.id + '" role="group" aria-labelledby="filter-trigger-' + o.id + '" class="gf-option-block gf-option-' + o.id + ' gf-option-block-' + (o.darstellung === 'auswahl' ? 'select' : 'checkbox') + ' swatch-size-32' + (auf ? '' : ' is-collapsed') + '">' +
      titelBlock(o, auf, gewaehlt) + '<div class="gf-block-content" id="filter-content-' + o.id + '" role="region" aria-labelledby="filter-trigger-' + o.id + '"><div class="gf-scroll">';
    if (o.darstellung === 'auswahl') {
      return kopf + '<div class="gf-option-box" id="filter-' + o.id + '-results"><select data-fid="' + o.id + '" aria-labelledby="filter-trigger-' + o.id + '"><option value="">Auswählen</option>' +
        werte.map((w) => '<option value="' + esc(w.wert) + '"' + (istGewaehlt(o, w.wert) ? ' selected="selected"' : '') + '>' + esc(w.wert) + ' (' + zahlen[w.wert] + ')</option>').join('') + '</select></div></div></div></div>';
    }
    return kopf + '<ul class="gf-option-box" id="filter-' + o.id + '-results" aria-labelledby="filter-trigger-' + o.id + '">' +
      werte.map((w) => { const an = istGewaehlt(o, w.wert); return '<li><button type="button" aria-label="' + esc(w.wert) + '" role="checkbox" aria-checked="' + an + '"' + (an ? ' class="checked"' : '') + ' data-fid="' + o.id + '" data-fvalue="' + esc(w.wert) + '"><span class="gf-Checkbox"></span><span class="gf-label">' + esc(w.wert) + '</span><span class="gf-count">(' + zahlen[w.wert] + ')</span></button></li>'; }).join('') +
      '</ul></div></div></div>';
  }

  // Aktive Filter als Pillen (Leiste am Rechner, Kopf des Handy-Menüs)
  function aktiveFilter() {
    const liste = [];
    for (const o of optionen) {
      if (o.typ === 'preis') { if (z.preis) liste.push({ o, wert: euro(z.preis.min) + ' - ' + euro(z.preis.max), preis: true }); }
      else for (const wert of z.auswahl[o.id] || []) liste.push({ o, wert });
    }
    return liste;
  }
  function pillen() {
    const aktiv = aktiveFilter();
    const pille = (f, handy) => '<a tabindex="0" role="button" class="refine-by-multi-filter" data-fid="' + f.o.id + '"' + (f.preis ? '' : ' data-fvalue="' + esc(f.wert) + '"') + ' aria-label="Filter entfernen: ' + esc(f.o.titel + ' ' + f.wert) + '"> <span class="selected-item"> <span' + (handy ? '' : ' class="hidden-xs"') + '>' + esc(f.o.titel) + '</span> <strong> <span class="gf-label">' + esc(f.wert) + '</span> </strong> </span> <span class="gf-clear"> ' + (handy ? ICON_X : ICON_PILLE) + ' </span> </a>';
    const oben = leiste.querySelector('.globo-selected-items-wrapper');
    // „Alle Löschen“ zeigt die App in der Leiste erst ab zwei aktiven Filtern
    oben.innerHTML = aktiv.length ? '<ul class="globo-selected-items">' + (aktiv.length > 1 ? '<li class="selected-item gf-option-label"><a tabindex="0" role="button" class="clear-refinements">Alle Löschen</a></li>' : '') + aktiv.map((f) => '<li class="selected-item gf-option-label">' + pille(f, false) + '</li>').join('') + '</ul>' : '';
    let unten = tree.querySelector('.globo-selected-items-wrapper');
    if (!unten) {
      unten = document.createElement('div');
      unten.className = 'globo-selected-items-wrapper visible-xs rounded';
      unten.style.cssText = '--text-color: #000000; --icon-color: #959595; --bg-color: #E8E8E8';
      inhalt.before(unten);
    }
    unten.innerHTML = aktiv.length ? '<div class="gf-block-title"><div class="h3"><span>' + esc(tree.querySelector('#gf-filter-title').textContent) + '</span></div><a tabindex="0" role="button" class="gf-refine-toggle">Alle Löschen</a></div><div class="gf-block-content globo-selected-items">' + aktiv.map((f) => '<div class="selected-item gf-option-label">' + pille(f, true) + '</div>').join('') + '</div>' : '';
  }

  // Seitenzahlen wie bei der App: erste, letzte und zwei Seiten um die aktuelle, Lücken als „…“
  function seitenleiste(s) {
    if (s.anzahl <= 1) { nav.innerHTML = ''; return; }
    const basis = location.origin + location.pathname + url(p, 'page'); // wie die App: Adresse ohne page, „page=N“ ans Ende
    const link = (n, inhaltHtml, klasse, label) => '<a class="gspf-page pagination__link ' + klasse + '" href="' + esc(basis + (basis.includes('?') ? '&' : '?') + 'page=' + n) + '" data-page="' + n + '"' + (label ? ' aria-label="' + label + '"' : '') + '>' + inhaltHtml + '</a>';
    const nummern = [];
    for (let n = 1; n <= s.anzahl; n++) if (n === 1 || n === s.anzahl || Math.abs(n - s.seite) <= 2) nummern.push(n);
    let li = '<li class="pagination__item">' + (s.seite > 1 ? link(s.seite - 1, pfeil('M6.5 11L1.5 6L6.5 1'), 'pagination__link--arrow', 'Vorherige Seite') : '<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-disabled="true" aria-label="Vorherige Seite">' + pfeil('M6.5 11L1.5 6L6.5 1') + '</span>') + '</li>';
    let vorher = 0;
    for (const n of nummern) {
      if (n - vorher > 1) li += '<li class="pagination__item"><span class="pagination__link pagination__link--gap" aria-hidden="true">…</span></li>';
      li += '<li class="pagination__item">' + (n === s.seite ? '<span class="pagination__link pagination__link--page pagination__link--current" aria-current="page">' + n + '</span>' : link(n, String(n), 'pagination__link--page')) + '</li>';
      vorher = n;
    }
    li += '<li class="pagination__item">' + (s.seite < s.anzahl ? link(s.seite + 1, pfeil('M1.5 1L6.5 6L1.5 11'), 'pagination__link--arrow', 'Nächste Seite') : '<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-disabled="true" aria-label="Nächste Seite">' + pfeil('M1.5 1L6.5 6L1.5 11') + '</span>') + '</li>';
    nav.innerHTML = '<nav class="pagination" aria-label="Seiten" data-current_page="' + s.seite + '"><ul class="pagination__list" role="list">' + li + '</ul></nav>';
  }

  const produkteText = (n) => '<b>' + n + '</b> ' + (n === 1 ? 'Produkt' : 'Produkte');

  async function anwenden(neu, verlauf) {
    p = neu;
    z = L.zustandAusUrl(url(p), optionen);
    const s = sortierung();
    if (z.suche) await suchindexLaden();
    const ord = await ordnung(schluesselFuer(s));
    for (const p of produkte) p.index = ord.has(p.handle) ? ord.get(p.handle) : 1e6 + p.start;
    const treffer = L.sortieren(L.filtern(produkte, optionen, z), s);
    const sl = L.seiten(treffer, z.limit || 12, z.seite);
    // Karten
    const sichtbar = new Set(sl.liste);
    // 21.10.2026: hidden nur bei Änderung schreiben, Karten nur umhängen, wenn die Reihenfolge vorne abweicht (Ergebnis gleich)
    for (const p of produkte) { const aus = !sichtbar.has(p); if (p.el.hidden !== aus) p.el.hidden = aus; }
    if (sl.liste.some((p, i) => raster.children[i] !== p.el)) raster.prepend(...sl.liste.map((p) => p.el)); // sichtbare Karten zuerst, damit :nth-child-Regeln wie bei der App greifen
    let leer = raster.querySelector('.jars-keine-treffer');
    if (!treffer.length && !leer) raster.insertAdjacentHTML('afterbegin','<div class="spf-col-xl-12 spf-col-lg-12 spf-col-md-12 spf-col-sm-12 jars-keine-treffer" role="listitem" style="grid-column: 1 / -1;width: 100%;max-width: 100%;"> Keine Produkte verfügbar </div>');
    else if (treffer.length && leer) leer.remove();
    // Filterspalte (Fokus bleibt auf dem bedienten Element)
    const fokus = document.activeElement && tree.contains(document.activeElement) ? (document.activeElement.id ? '#' + document.activeElement.id : document.activeElement.dataset.fvalue !== undefined ? '[data-fid="' + document.activeElement.dataset.fid + '"][data-fvalue="' + CSS.escape(document.activeElement.dataset.fvalue) + '"]' : null) : null;
    inhalt.innerHTML = optionen.map((o) => (o.typ === 'preis' ? preisBlock(o, L.filtern(produkte, optionen, z, 'preis')) : werteBlock(o))).join('');
    if (fokus) inhalt.querySelector(fokus)?.focus();
    pillen();
    // Leiste
    leiste.querySelector('.gf-summary').innerHTML = produkteText(treffer.length);
    tree.querySelector('.gf-filter-footer button').innerHTML = 'Anzeigen ' + produkteText(treffer.length);
    leiste.querySelector('#filtered-products-results-count').textContent = treffer.length + (treffer.length === 1 ? ' Produkt' : ' Produkte') + ' gefunden.';
    sortKnopf.querySelector('span').textContent = SORT_TEXT[z.sortierung] || STANDARD_TEXT;
    for (const li of sortListe.children) li.setAttribute('aria-selected', String(li.dataset.sort === s));
    if (document.activeElement !== suchfeld) suchfeld.value = p.q === undefined ? '' : String(p.q);
    limitWahl.value = [12, 24, 48].includes(z.limit) ? String(z.limit) : '12';
    seitenleiste(sl);
    if (verlauf) {
      // Wie die App: neuer Eintrag nur bei geänderter Adresse, sonst ersetzen (ohne den zusätzlichen Eintrag der App beim Laden)
      const ziel = location.pathname + url(p);
      history[verlauf === 'neu' && ziel !== location.pathname + location.search + location.hash ? 'pushState' : 'replaceState']({ jarsFilter: true, parameter: p }, '', ziel);
    }
    fertig();
  }

  // Jede Bedienung ändert die Parameter genau wie die App (window.toggleCheckboxFilter, removeFilter, … in globo.filter.filter.min.js)
  const aendern = (f) => { const neu = structuredClone(p); f(neu); return anwenden(neu, 'neu'); };
  // Abwählen trifft auch Rohwerte mit Leerzeichen aus Hand-Links (die App hängte dann den Wert ein zweites Mal an)
  const gleich = (a, b) => String(a).trim() === String(b).trim();
  const ohneWert = (n, fid, wert) => { const rest = n.filter[fid].filter((w) => !gleich(w, wert)); if (rest.length) n.filter[fid] = rest; else delete n.filter[fid]; };
  const wertUmschalten = (fid, wert, einzeln) => aendern((n) => {
    L.seiteZuruecksetzen(n);
    n.filter = n.filter || {};
    const liste = n.filter[fid];
    if (einzeln) { if (wert) n.filter[fid] = [wert]; else delete n.filter[fid]; }
    else if (!liste) n.filter[fid] = [wert];
    else if (liste.some((w) => gleich(w, wert))) ohneWert(n, fid, wert);
    else liste.push(wert);
  });
  const wertEntfernen = (fid, wert) => aendern((n) => {
    if (!(n.filter && n.filter[fid] && n.filter[fid].some((w) => gleich(w, wert)))) return;
    ohneWert(n, fid, wert);
    L.seiteZuruecksetzen(n);
  });
  const optionLoeschen = (fid) => aendern((n) => { if (n.filter && fid in n.filter) { delete n.filter[fid]; L.seiteZuruecksetzen(n); } });
  const allesLoeschen = () => aendern((n) => { if (n.filter) { delete n.filter; L.seiteZuruecksetzen(n); } });

  // ---------- Ereignisse ----------
  tree.addEventListener('click', (e) => {
    const t = e.target;
    const wert = t.closest('button[data-fvalue]');
    if (wert) return wertUmschalten(+wert.dataset.fid, wert.dataset.fvalue);
    const loeschen = t.closest('.gf-block-title .gf-clear');
    if (loeschen) { e.preventDefault(); return optionLoeschen(+loeschen.dataset.fid); }
    const titel = t.closest('.gf-block-title .h3[role="button"]');
    if (titel) return blockUmschalten(titel);
    const pille = t.closest('.refine-by-multi-filter');
    if (pille) { e.preventDefault(); return pille.dataset.fvalue !== undefined ? wertEntfernen(+pille.dataset.fid, pille.dataset.fvalue) : optionLoeschen(+pille.dataset.fid); }
    if (t.closest('.gf-refine-toggle')) { e.preventDefault(); return allesLoeschen(); }
    if (t.closest('.gf-close-canvas, .gf-filter-footer button')) return menue(false);
  });
  tree.addEventListener('keydown', (e) => {
    const titel = e.target.closest('.gf-block-title .h3[role="button"]');
    if (titel && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); blockUmschalten(titel); }
    if (e.key === 'Escape' && html.classList.contains('offcanvas-open')) menue(false);
  });
  // „Löschen“, „Alle Löschen“ und Pillen sind wie bei der App Links ohne Ziel: per Tastatur wie Knöpfe bedienbar
  const tasteWieKlick = (e) => { if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('a[role="button"]')) { e.preventDefault(); e.target.click(); } };
  tree.addEventListener('keydown', tasteWieKlick);
  leiste.addEventListener('keydown', tasteWieKlick);
  tree.addEventListener('change', (e) => {
    const sel = e.target.closest('select[data-fid]');
    if (sel) wertUmschalten(+sel.dataset.fid, sel.value, true);
  });
  function blockUmschalten(titel) {
    const block = titel.closest('.gf-option-block');
    const id = +block.dataset.filterId;
    const auf = block.classList.toggle('is-collapsed') === false;
    titel.setAttribute('aria-expanded', String(auf));
    if (block.dataset.filterType === 'Price') { if (auf) offen.add(id); else offen.delete(id); } else if (auf) zu.delete(id); else zu.add(id);
  }

  // Preis: Eingabefelder (Enter oder Verlassen) und Schieberegler
  function preisSetzen(o, min, max) {
    const slider = inhalt.querySelector('#slider-' + o.id);
    const lo = +slider.dataset.min, hi = +slider.dataset.max;
    if (!(min <= max)) [min, max] = [max, min];
    min = Math.max(lo, Math.min(hi, min)); max = Math.max(lo, Math.min(hi, max));
    return aendern((n) => { L.seiteZuruecksetzen(n); (n.filter = n.filter || {})[o.id] = [zahl(min) + ':' + zahl(max)]; });
  }
  const preisOption = () => optionen.find((o) => o.typ === 'preis');
  function preisAusFeldern() {
    const o = preisOption();
    const lesen = (sel) => parseFloat(String(inhalt.querySelector(sel)?.value || '').replace(',', '.'));
    const min = lesen('.gf-range-min'), max = lesen('.gf-range-max');
    if (isNaN(min) || isNaN(max)) return anwenden(z);
    const alt = z.preis || {};
    const slider = inhalt.querySelector('#slider-' + o.id);
    if (!z.preis && min === +slider.dataset.min && max === +slider.dataset.max) return;
    if (alt.min === min && alt.max === max) return;
    preisSetzen(o, min, max);
  }
  inhalt.addEventListener('keydown', (e) => { if (e.target.matches('.gf-range-min, .gf-range-max') && e.key === 'Enter') { e.preventDefault(); preisAusFeldern(); } });
  inhalt.addEventListener('focusout', (e) => { if (e.target.matches('.gf-range-min, .gf-range-max') && !inhalt.contains(e.relatedTarget && e.relatedTarget.matches('.gf-range-min, .gf-range-max') ? e.relatedTarget : null)) preisAusFeldern(); });

  // Schieberegler: Griff ziehen, auf die Leiste tippen, Pfeiltasten
  let zug = null;
  function reglerZeigen(slider, werte) {
    const lo = +slider.dataset.min, hi = +slider.dataset.max;
    const pos = werte.map((v) => (hi > lo ? ((v - lo) / (hi - lo)) * 100 : 0));
    slider.querySelectorAll('.noUi-origin').forEach((or, k) => { or.style.transform = 'translate(' + (pos[k] - 100) * 10 + '%, 0px)'; or.firstChild.setAttribute('aria-valuenow', zahl(werte[k])); or.firstChild.setAttribute('aria-valuetext', werte[k].toFixed(2)); });
    slider.querySelector('.noUi-connect').style.transform = 'translate(' + pos[0] + '%, 0px) scale(' + (pos[1] - pos[0]) / 100 + ', 1)';
    inhalt.querySelector('.gf-range-min').value = zahl(werte[0]);
    inhalt.querySelector('.gf-range-max').value = zahl(werte[1]);
  }
  const reglerWerte = (slider) => [...slider.querySelectorAll('.noUi-handle')].map((h) => +h.getAttribute('aria-valuenow'));
  inhalt.addEventListener('pointerdown', (e) => {
    const slider = e.target.closest('.gf-range-slider');
    if (!slider || e.button > 0) return;
    const basis = slider.querySelector('.noUi-base').getBoundingClientRect();
    const lo = +slider.dataset.min, hi = +slider.dataset.max;
    const wertBei = (x) => Math.round((lo + Math.min(1, Math.max(0, (x - basis.left) / basis.width)) * (hi - lo)) * 100) / 100;
    const werte = reglerWerte(slider);
    const griff = e.target.closest('.noUi-handle');
    const k = griff ? +griff.dataset.handle : Math.abs(wertBei(e.clientX) - werte[0]) <= Math.abs(wertBei(e.clientX) - werte[1]) ? 0 : 1;
    zug = { slider, k, werte, wertBei };
    slider.setPointerCapture(e.pointerId);
    slider.querySelector('.noUi-handle-' + (k ? 'upper' : 'lower')).focus({ preventScroll: true });
    e.preventDefault();
    if (!griff) bewegen(e);
  });
  function bewegen(e) {
    if (!zug) return;
    const v = zug.wertBei(e.clientX);
    zug.werte[zug.k] = zug.k ? Math.max(v, zug.werte[0]) : Math.min(v, zug.werte[1]);
    reglerZeigen(zug.slider, zug.werte);
  }
  inhalt.addEventListener('pointermove', bewegen);
  const loslassen = () => { if (!zug) return; const { werte } = zug; zug = null; preisSetzen(preisOption(), werte[0], werte[1]); };
  inhalt.addEventListener('pointerup', loslassen);
  inhalt.addEventListener('pointercancel', loslassen);
  let tastenZeit;
  inhalt.addEventListener('keydown', (e) => {
    const griff = e.target.closest('.noUi-handle');
    if (!griff) return;
    const slider = griff.closest('.gf-range-slider');
    const lo = +slider.dataset.min, hi = +slider.dataset.max;
    const schritt = { ArrowLeft: -0.01, ArrowDown: -0.01, ArrowRight: 0.01, ArrowUp: 0.01, PageDown: -0.1, PageUp: 0.1 }[e.key];
    const werte = reglerWerte(slider);
    const k = +griff.dataset.handle;
    if (schritt) werte[k] += schritt * (hi - lo);
    else if (e.key === 'Home') werte[k] = k ? werte[0] : lo;
    else if (e.key === 'End') werte[k] = k ? hi : werte[1];
    else return;
    e.preventDefault();
    werte[k] = Math.round(Math.min(k ? hi : werte[1], Math.max(k ? werte[0] : lo, werte[k])) * 100) / 100;
    reglerZeigen(slider, werte);
    clearTimeout(tastenZeit);
    tastenZeit = setTimeout(() => preisSetzen(preisOption(), werte[0], werte[1]).then(() => inhalt.querySelector('.noUi-handle-' + (k ? 'upper' : 'lower'))?.focus()), 600);
  });

  // Leiste: Pillen, Anzahl je Seite, Sortierung, Suche, Handy-Menü
  leiste.addEventListener('click', (e) => {
    const pille = e.target.closest('.refine-by-multi-filter');
    if (pille) { e.preventDefault(); return pille.dataset.fvalue !== undefined ? wertEntfernen(+pille.dataset.fid, pille.dataset.fvalue) : optionLoeschen(+pille.dataset.fid); }
    if (e.target.closest('.clear-refinements')) { e.preventDefault(); return allesLoeschen(); }
  });
  limitWahl.addEventListener('change', () => aendern((n) => { L.seiteZuruecksetzen(n); n.limit = parseInt(limitWahl.value, 10); }));

  const sortBox = sortKnopf.parentElement;
  function sortMenue(auf) {
    sortBox.classList.toggle('active', auf);
    sortKnopf.setAttribute('aria-expanded', String(auf));
    if (auf) (sortListe.querySelector('[aria-selected="true"]') || sortListe.firstElementChild).focus();
  }
  sortKnopf.addEventListener('click', () => sortMenue(!sortBox.classList.contains('active')));
  sortListe.addEventListener('click', (e) => {
    const li = e.target.closest('li[data-sort]');
    if (!li) return;
    sortMenue(false);
    sortKnopf.focus();
    if (p.sort_by !== li.dataset.sort) aendern((n) => { L.seiteZuruecksetzen(n); n.sort_by = li.dataset.sort; });
  });
  sortListe.addEventListener('keydown', (e) => {
    const li = e.target.closest('li[data-sort]');
    if (!li) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') { e.preventDefault(); (e.key === 'ArrowDown' ? li.nextElementSibling : li.previousElementSibling)?.focus(); }
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); li.click(); }
    else if (e.key === 'Escape') { sortMenue(false); sortKnopf.focus(); }
  });
  document.addEventListener('click', (e) => { if (sortBox.classList.contains('active') && !e.composedPath().includes(sortBox)) sortMenue(false); });

  const suchForm = suchfeld.form;
  // Wie die App: Suche wirkt beim Tippen (Text roh, auch mit Leerzeichen am Ende) und setzt sort_by=relevance;
  // Leeren entfernt q und setzt die Standardsortierung
  const suchen = () => {
    const q = suchfeld.value;
    if (q === (p.q === undefined ? '' : String(p.q))) return;
    return aendern((n) => { if (q) { n.q = q; n.sort_by = 'relevance'; } else { delete n.q; n.sort_by = E.standardSortierung; } L.seiteZuruecksetzen(n); });
  };
  suchForm.addEventListener('submit', (e) => { e.preventDefault(); suchen(); });
  let suchZeit;
  suchfeld.addEventListener('input', () => { clearTimeout(suchZeit); suchZeit = setTimeout(suchen, 500); });
  // 21.10.2026: Suchindex schon beim Fokus vorladen (erst wenn die Karten erfasst sind), damit die erste Suche nicht darauf wartet
  suchfeld.addEventListener('focus', () => { if (produkte.length) suchindexLaden().catch(() => {}); });
  suchForm.querySelector('.gf-controls-clear-button').addEventListener('click', () => { suchfeld.value = ''; clearTimeout(suchZeit); suchen(); suchfeld.focus(); });

  // Seitenzahlen: ohne Neuladen, nach oben zum Raster
  nav.addEventListener('click', (e) => {
    const a = e.target.closest('a[data-page]');
    if (!a) return;
    e.preventDefault();
    aendern((n) => { n.page = +a.dataset.page; }).then(() => {
      // App: springt an den Anfang des Rasters; hier zusätzlich unter den festen Kopfbereich
      const kopf = document.getElementById('jars-header') || document.querySelector('header');
      const oben = document.getElementById('gf-grid').getBoundingClientRect().top + scrollY - (kopf ? Math.min(kopf.getBoundingClientRect().bottom, 190) : 0) - 10;
      if (scrollY > oben) window.scrollTo({ top: Math.max(0, oben) });
    });
  });

  // Handy-Menü (Seitenleiste von links)
  function menue(auf) {
    html.classList.toggle('offcanvas-open', auf);
    tree.setAttribute('aria-hidden', String(!auf));
    filterKnopf.setAttribute('aria-expanded', String(auf));
    if (auf) tree.querySelector('.gf-close-canvas').focus(); else if (HANDY.matches) filterKnopf.focus();
  }
  filterKnopf.addEventListener('click', (e) => { e.stopPropagation(); menue(true); });
  // Tippen neben das Menü schließt es (gemessen)
  // composedPath statt contains: ein angetippter Wert ist nach dem Neuaufbau der Liste schon aus dem Dokument entfernt
  document.addEventListener('click', (e) => { if (html.classList.contains('offcanvas-open') && !e.composedPath().includes(tree)) menue(false); });
  // Wie die App: am Handy hängt die Filterspalte als letztes Element in <body> (Regeln „body > #gf-tree“), am Rechner vor dem Raster
  const rasterHuelle = document.getElementById('gf-grid');
  function rolle() {
    if (HANDY.matches) { if (tree.parentElement !== document.body) document.body.appendChild(tree); }
    else if (tree.nextElementSibling !== rasterHuelle) rasterHuelle.before(tree);
    if (HANDY.matches) { tree.setAttribute('role', 'dialog'); tree.setAttribute('aria-modal', 'true'); tree.setAttribute('aria-labelledby', 'gf-filter-title'); tree.setAttribute('aria-hidden', String(!html.classList.contains('offcanvas-open'))); }
    else { ['role', 'aria-modal', 'aria-labelledby', 'aria-hidden'].forEach((a) => tree.removeAttribute(a)); html.classList.remove('offcanvas-open'); }
  }
  HANDY.addEventListener('change', rolle);

  // Zurück/Vor im Browser
  window.addEventListener('popstate', (e) => anwenden(e.state && e.state.parameter ? e.state.parameter : L.parameterAusUrl(location.search, E.standardSortierung)));

  // Aktion beginnt oder endet bei offener Seite (Ereignis aus snippets/jars-aktion-kopf.liquid): Preise, Preisregler und
  // Sortierung „% Rabatt“ neu rechnen, Adresse bleibt unverändert (09.10.2026)
  document.addEventListener('jars:aktion', () => {
    if (!produkte.length) return;
    for (const pr of produkte) Object.assign(pr, preisDaten(pr.el));
    anwenden(p).catch((fehler) => console.error('JARS Filter:', fehler));
  });

  // Theme-Editor: nach einer Änderung an dieser Section baut Shopify sie neu auf; Vorschau neu laden, damit der Filter neu startet
  if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:section:load', (e) => { if (e.detail && e.detail.sectionId === E.abschnitt) location.reload(); });

  // ---------- Schnellansicht (Auge auf der Karte), Aufbau und Klassen wie die App ----------
  const PFEIL_LINKS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M11.764 5.204a.75.75 0 0 1 .032 1.06l-3.516 3.736 3.516 3.736a.75.75 0 1 1-1.092 1.028l-4-4.25a.75.75 0 0 1 0-1.028l4-4.25a.75.75 0 0 1 1.06-.032Z"></path></svg>';
  const PFEIL_RECHTS = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" aria-hidden="true"><path fill-rule="evenodd" d="M7.72 14.53a.75.75 0 0 1 0-1.06l3.47-3.47-3.47-3.47a.75.75 0 0 1 1.06-1.06l4 4a.75.75 0 0 1 0 1.06l-4 4a.75.75 0 0 1-1.06 0Z"></path></svg>';
  const bildGroesse = (url, g) => String(url).replace(/(\.[a-z0-9]+)(\?|$)/i, '_' + g + '$1$2');
  let qv = null;

  // Preis der Schnellansicht über dieselbe Regel wie alle Preisstellen (assets/jars-preis.js), in einer Aktion beide Zustände
  // (09.10.2026); seit 29.10.2026 mit Vergleichspreis wie jars-preis-werte (nie bei B-Ware oder Gutschein).
  function qvPreis(v, p) {
    // Gutschein (keine versandpflichtige Variante) nie in der Aktion, wie product.gift_card? in jars-preis-stufe.liquid
    const ware = p.variants.some((x) => x.requires_shipping);
    const tags = ware ? p.tags : [];
    const bware = String(p.title || '').trim().toLowerCase().startsWith('b-ware') ||
      (p.tags || []).some((t) => String(t).trim().toLowerCase() === 'b-ware');
    const vergleich = ware && !bware ? v.compare_at_price : 0;
    if (window.JarsPreis) return JarsPreis.html(JarsPreis.werte(tags, v.id, v.price, vergleich), 'gfqv', (c) => euro(c / 100));
    return '<span class="gfqv-product-card__price money">' + euro(v.price / 100) + '</span>';
  }

  // Pflichtangaben im Angebot der Schnellansicht (09.10.2026): Preis-Zusatz (PAngV § 6), EU-Gewährleistungshinweis, Hersteller (GPSR Art. 19).
  // Texte und Regeln kommen aus den Liquid-Bausteinen über das Einstellungs-JSON (jars-preis-hinweis, jars-herstellerangabe), damit sie
  // überall gleich lauten. Steht unter dem Formular und nicht im price-wrapper, weil der Variantenwechsel den Preis per innerHTML ersetzt.
  function herstellerBelegt(p) {
    const h = E.hersteller;
    if (!h) return false;
    const ware = p.variants.some((v) => v.requires_shipping);
    const titel = String(p.title || '').toLowerCase();
    const text = String(p.description || '').toLowerCase();
    let belegt = ware && String(p.title || '').toUpperCase().includes('JARS') && (titel.includes('messer') || titel.includes('knife')) &&
      !h.teile.some((w) => titel.includes(w)) && !h.stichwoerter.some((w) => titel.includes(w) || text.includes(w));
    if (ware && h.zusaetzlich.includes(p.handle)) belegt = true;
    if (h.ausgenommen.includes(p.handle)) belegt = false;
    return belegt;
  }
  function qvPflicht(p) {
    if (!p.variants.some((v) => v.requires_shipping)) return ''; // Gutschein: kein Versand, keine Gewährleistungsmitteilung
    const teile = [];
    if (E.preisHinweis) teile.push(E.preisHinweis);
    if (E.euMitteilung) teile.push('<a class="gfqv-pflicht__eu" href="' + esc(E.euMitteilung) + '" target="_blank" rel="noopener">Deine gesetzlichen Gewährleistungsrechte (amtlicher EU-Hinweis)</a>');
    if (herstellerBelegt(p)) teile.push('<span class="gfqv-pflicht__hersteller">' + E.hersteller.text + '</span>');
    return teile.length ? ' <div class="gfqv-pflicht">' + teile.join('') + '</div>' : '';
  }

  async function schnellansicht(url, ausloeser) {
    const p = await (await fetch(url.split(/[?#]/)[0] + '.js', { credentials: 'same-origin' })).json();
    const v0 = p.variants.find((v) => v.available) || p.variants[0];
    const mitAuswahl = !(p.variants.length === 1 && p.variants[0].title === 'Default Title');
    // Wie die App: alle Galeriebilder (600er) sofort laden, die Bühne wird so hoch wie das höchste Bild.
    // Breite/Höhe als Attribute reservieren den Platz schon während des Ladens.
    const medien = (p.media || []).filter((m) => m.media_type === 'image');
    const bilder = p.images.map((src, i) => {
      const m = medien[i];
      if (!m || !m.width) return { src, masse: '' };
      const f = Math.min(1, 600 / m.width, 600 / m.height); // wie Shopifys _600x600: einpassen, nie vergrößern
      return { src, masse: ' width="' + Math.round(m.width * f) + '" height="' + Math.round(m.height * f) + '"' };
    });
    const swatches = mitAuswahl ? '<div class="gfqv-swatchs">' + p.options.map((o, k) => '<div class="gfqv-swatch" data-option="' + (k + 1) + '"> <label id="gfqv-opt-' + k + '">' + esc(o.name) + ': <span class="gfqv-current-value">' + esc(v0.options[k]) + '</span></label> <ul class="gfqv-swatch-values" role="radiogroup" aria-labelledby="gfqv-opt-' + k + '">' +
      o.values.map((w) => '<li class="gfqv-swatch-value' + (w === v0.options[k] ? ' is-selected' : '') + '" data-value="' + esc(w) + '" role="radio" tabindex="0" aria-checked="' + (w === v0.options[k]) + '"> <span class="gfqv-product__swatch-outer"> <span class="gfqv-product__swatch-inner"><span class="gfqv-swatch-text">' + esc(w) + '</span></span> </span> </li>').join('') + '</ul> </div>').join('') + '</div>' : '';
    const modal = document.createElement('div');
    modal.id = 'gfqv-modal';
    modal.className = 'gfqv-modal';
    modal.tabIndex = -1;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', p.title);
    modal.innerHTML = '<div class="gfqv-modal-content"> <div class="gfqv-container"><div class="product"> <span class="gfqv-close-modal" role="button" tabindex="0" aria-label="Schließen"></span> <div class="gfqv-product-wrapper"> <div class="spf-row">' +
      '<div class="spf-col-md-6 spf-col-sm-12 spf-col-xs-12 product-images-wrapper"> <div class="gfqv-product-images-wrapper"> <div class="gfqv-product-gallery"> <figure class="gfqv-product-images owl-carousel owl-loaded owl-drag"> <div class="owl-stage-outer"><div class="owl-stage" style="transform: translate3d(0px, 0px, 0px); transition: all;">' +
      bilder.map((b, i) => '<div class="owl-item' + (i ? '' : ' active') + '"><div class="gfqv-product-image"> <img src="' + esc(bildGroesse(b.src, '600x600')) + '" alt="' + esc(p.title) + '"' + b.masse + '> </div></div>').join('') +
      '</div></div><div class="owl-nav' + (bilder.length > 1 ? '' : ' disabled') + '"><button type="button" class="owl-prev" aria-label="Vorheriges Bild">' + PFEIL_LINKS + '</button><button type="button" class="owl-next" aria-label="Nächstes Bild">' + PFEIL_RECHTS + '</button></div><div class="owl-dots disabled"></div></figure> </div>' +
      ' <div class="gfqv-product-thumbnails"> <div class="gfqv-thumbnails">' + bilder.map((b, i) => '<div class="gfqv-thumbnail" data-index="' + i + '" role="button" tabindex="0" aria-label="Bild ' + (i + 1) + '"> <img src="' + esc(bildGroesse(b.src, '70x70')) + '" alt="" loading="lazy"> </div>').join(' ') + '</div> </div> </div> </div>' +
      '<div class="spf-col-md-6 spf-col-sm-12 spf-col-xs-12 spf-col-md-offset-1 gfqv-product-summary"> <div class="gfqv-product-details"> <h1 class="gfqv-product-title"><a href="' + esc(url.split(/[?#]/)[0]) + '">' + esc(p.title) + '</a></h1> <div class="gfqv-product-rating"></div> <div> <div class="gfqv-product-card__price-wrapper">' + qvPreis(v0, p) + '</div> </div> <div class="gfqv-description"></div>' +
      '<form action="' + (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add" method="post" enctype="multipart/form-data" class="gfqv-product-form"> <select name="id" id="gfqv-select" aria-label="Variante">' + p.variants.map((v) => '<option value="' + v.id + '"' + (v.id === v0.id ? ' selected="selected"' : '') + '>' + esc(v.title) + '</option>').join('') + '</select>' + swatches +
      '<div class="variations_button"> <div class="quantity"> <span class="decrease ion-ios-minus-empty" role="button" tabindex="0" aria-label="Menge verringern"></span> <input type="number" step="1" min="1" max="20" readonly name="quantity" value="1" title="Menge" aria-label="Menge" class="input-text qty text" size="4" inputmode="numeric"> <span class="increase ion-ios-plus-empty" role="button" tabindex="0" aria-label="Menge erhöhen"></span> </div> </div>' +
      ' <div id="gfqv-btn-wrap"> <button type="submit" id="gfqv-btn"' + (v0.available ? '' : ' disabled') + '>' + (v0.available ? 'Zum Warenkorb' : 'Nicht verfügbar') + '</button> </div> </form>' + qvPflicht(p) + ' <div class="clear"></div> </div> </div> </div> </div></div> </div></div>';
    // Beschreibung wie auf der Produktseite, eigene Skripte der Beschreibung (z. B. Aufklapper) laufen mit
    // 21.10.2026: lazy für Beschreibungsbilder hier bewusst nicht (Code-Review: Bilder ohne Maße ließen den Inhalt beim Scrollen springen)
    const beschreibung = modal.querySelector('.gfqv-description');
    beschreibung.innerHTML = p.description || '';
    for (const alt of beschreibung.querySelectorAll('script')) { const neu = document.createElement('script'); neu.textContent = alt.textContent; alt.replaceWith(neu); }
    document.body.appendChild(modal);
    // 13.10.2026: KI-Kennzeichnung an Galerie, Vorschaubildern und Bildern der Beschreibung (assets/jars-ki-marke.js)
    if (window.jarsKiMarke) {
      modal.querySelectorAll('.gfqv-product-image img').forEach((b) => jarsKiMarke(b));
      modal.querySelectorAll('.gfqv-thumbnail img').forEach((b) => jarsKiMarke(b, { klein: true }));
      jarsKiBeschreibung(beschreibung);
    }
    html.classList.add('globo-modal-open');
    document.body.classList.add('globo-modal-open');
    qv = { modal, p, bild: 0, ausloeser };
    galerie(0);
    modal.focus({ preventScroll: true, focusVisible: false }); // ohne Fokusrahmen, wie bei der App
  }

  function galerie(i) {
    if (!qv) return;
    const n = qv.p.images.length;
    if (!n) return;
    qv.bild = (i + n) % n;
    const aussen = qv.modal.querySelector('.owl-stage-outer');
    const breite = aussen.clientWidth;
    const buehne = qv.modal.querySelector('.owl-stage');
    buehne.style.width = breite * n + 'px';
    qv.modal.querySelectorAll('.owl-item').forEach((it, k) => { it.style.width = breite + 'px'; it.classList.toggle('active', k === qv.bild); });
    buehne.style.transform = 'translate3d(' + -breite * qv.bild + 'px, 0px, 0px)';
    buehne.style.transition = 'all 0.25s ease 0s';
  }

  function variante() {
    const form = qv.modal.querySelector('.gfqv-product-form');
    const gewaehlt = [...form.querySelectorAll('.gfqv-swatch')].map((s) => s.querySelector('.is-selected')?.dataset.value);
    const v = qv.p.variants.find((x) => x.options.every((w, k) => w === gewaehlt[k]));
    const knopf = form.querySelector('#gfqv-btn');
    if (!v) { knopf.disabled = true; knopf.textContent = 'Nicht verfügbar'; return; }
    form.querySelector('#gfqv-select').value = String(v.id);
    qv.modal.querySelector('.gfqv-product-card__price-wrapper').innerHTML = qvPreis(v, qv.p);
    knopf.disabled = !v.available;
    knopf.textContent = v.available ? 'Zum Warenkorb' : 'Nicht verfügbar';
    if (v.featured_image) galerie(v.featured_image.position - 1);
  }

  function schnellansichtSchliessen() {
    if (!qv) return;
    qv.modal.remove();
    html.classList.remove('globo-modal-open');
    document.body.classList.remove('globo-modal-open');
    qv.ausloeser?.focus();
    qv = null;
  }

  document.addEventListener('click', (e) => {
    if (!qv) return;
    const t = e.target;
    if (t === qv.modal || t.closest('.gfqv-close-modal')) return schnellansichtSchliessen();
    if (t.closest('.owl-prev')) return galerie(qv.bild - 1);
    if (t.closest('.owl-next')) return galerie(qv.bild + 1);
    const daumen = t.closest('.gfqv-thumbnail');
    if (daumen) return galerie(+daumen.dataset.index);
    const wert = t.closest('.gfqv-swatch-value');
    if (wert) {
      const swatch = wert.closest('.gfqv-swatch');
      swatch.querySelectorAll('.gfqv-swatch-value').forEach((li) => { li.classList.toggle('is-selected', li === wert); li.setAttribute('aria-checked', String(li === wert)); });
      swatch.querySelector('.gfqv-current-value').textContent = wert.dataset.value;
      return variante();
    }
    const menge = t.closest('.quantity .decrease, .quantity .increase');
    if (menge) { const f = qv.modal.querySelector('.qty'); f.value = Math.min(20, Math.max(1, +f.value + (menge.classList.contains('increase') ? 1 : -1))); }
  });
  document.addEventListener('keydown', (e) => {
    if (!qv) return;
    if (e.key === 'Escape') return schnellansichtSchliessen();
    if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('.gfqv-close-modal, .gfqv-thumbnail, .gfqv-swatch-value, .quantity span')) { e.preventDefault(); e.target.click(); }
  });
  window.addEventListener('resize', () => qv && galerie(qv.bild));

  raster.addEventListener('click', (e) => {
    const auge = e.target.closest('.open-quick-view');
    if (!auge) return;
    e.preventDefault();
    schnellansicht(auge.getAttribute('href'), auge).catch(() => { location.href = auge.getAttribute('href'); });
  });

  // ---------- Start ----------
  (async function start() {
    try {
      rolle();
      let karten = [...raster.querySelectorAll(':scope > [data-handle]')];
      const urlSort = new URLSearchParams(location.search).get('sort_by');
      const domSchluessel = SHOPIFY_SORTEN.includes(urlSort) && urlSort !== E.standardSortierung ? urlSort : 'standard';
      if (+raster.dataset.seiten > 1 || +raster.dataset.seite > 1) {
        // ?page=N mit N > 1 (Shopify zeigt dann eine leere Seite) oder mehr als 250 Produkte: vollständige Liste holen
        karten = kartenAus(await abschnittLaden(E.abschnitt, domSchluessel === 'standard' ? {} : { sort_by: domSchluessel })).map((k) => document.importNode(k, true));
        raster.replaceChildren(...karten);
      }
      ordnungen.set(domSchluessel, new Map(karten.map((k, i) => [k.dataset.handle, i])));
      produkte = L.vorbereiten(karten.map(aufnehmen), optionen, L.zusatzLesen(E.zusatz));
      // Stahl-Werte: feste Liste aus dem Editor (wie die Werteliste der App, 13.10.2026); leer = aus den Tags
      // (Schreibweise wie im Tag, sortiert wie bei der App)
      for (const o of optionen.filter((x) => x.typ === 'liste')) {
        const fest = String(o.liste || '').split(/\r?\n/).map((s) => s.trim()).filter(Boolean);
        // nur Werte, die in dieser Kollektion vorkommen (wie die App; unbekannte Werte würden sonst alle Produkte zählen)
        if (fest.length) { o.werte = fest.filter((wert) => o._bekannt.has(wert.replace(/\s+/g, ' ').trim().toLowerCase())).map((wert) => ({ wert })); continue; }
        const gesehen = new Map();
        for (const p of produkte) for (const t of p.tags) { const g = L.tagLesen(t); if (g && g.schluessel === o.schluessel && !gesehen.has(t.trim().toLowerCase())) gesehen.set(t.trim().toLowerCase(), t.trim()); }
        o.werte = [...gesehen.values()].sort((a, b) => (a < b ? -1 : a > b ? 1 : 0)).map((wert) => ({ wert }));
      }
      // Wie die App: Adresse beim Laden in ihre Form bringen (page=1, # und Standardsortierung weg, Reihenfolge), nicht im Theme-Editor
      await anwenden(p, window.Shopify && Shopify.designMode ? undefined : 'ersetzen');
    } catch (fehler) {
      console.error('JARS Filter:', fehler);
      fertig();
    }
  })();
})();
